
import VideoBanner from "./video-banner";
import extractOptions from "../../utilities/extractOptions";

export function exec() {

    const videoBannerElements = document.querySelectorAll("[data-video-banner]");

    const videoBannerElementsArray = Array.prototype.slice.call(videoBannerElements);

    videoBannerElementsArray.forEach(function(element) {
        const options = Object.assign(
            {},
            VideoBanner.DEFAULTS,
            extractOptions("video-banner", element)
        );
        const instance = new VideoBanner(element, options);
        element.instance = instance;
    });

}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/video-banner/index.js